import { useMemo } from 'react';
import { useDispatch, useSelector } from 'umi';

type LoadingKeyType = 'topicTrackingList' | 'topicTrackingTimeline';
export function useTopicTrackingLoading({
  key,
  index,
}: {
  key: LoadingKeyType;
  index?: number;
}) {
  const dispatch = useDispatch();
  const current = useSelector(({ opinionOrderLoading }: any) => {
    return opinionOrderLoading[key];
  });

  function finishLoading(key: LoadingKeyType, needSetLoading = false) {
    if (needSetLoading && typeof index === 'number') {
      dispatch({
        type: 'opinionOrderLoading/change',
        key,
        value: index + 1,
      });
    }
  }

  function resetLoading(needLoading = false) {
    if (needLoading) {
      dispatch({
        type: 'opinionOrderLoading/resetLoading',
        keys: ['topicTrackingTimeline', 'topicTrackingList'],
      });
    }
  }

  const [canRequest, needLoading] = useMemo(() => {
    if (typeof index !== 'number') return [true, false];
    return [current === index, current <= index];
  }, [current]);

  return {
    canRequest,
    finishLoading,
    resetLoading,
    needLoading,
  };
}
